import { Module } from "vuex";

import mutations from "./mutations";
import actions from "./actions";

import { PickYourOwnColorStoreState } from "./pickYourOwnColor.t";

const pickYourOwnColorModule: Module<PickYourOwnColorStoreState, any> = {
  mutations,
  actions,
  state: {
    isOpen: true,
    swatches: [],
    isRemoving: false,
  },
  namespaced: true,
};

export default pickYourOwnColorModule;
